import { useQuery } from '@tanstack/react-query'

import { fetchShipmentOrders } from '../api'
import { shipmentOrdersQueryKeys } from '../query-keys'

type UseRegularGroupOrdersParams = {
  tenantKey: string
  regularGroupId: string | null
  enabled?: boolean
}

export const useRegularGroupOrders = ({
  tenantKey,
  regularGroupId,
  enabled = true
}: UseRegularGroupOrdersParams) => {
  return useQuery({
    queryKey: shipmentOrdersQueryKeys.regularGroup(tenantKey, regularGroupId!),
    queryFn: ({ signal }) =>
      fetchShipmentOrders(
        {
          tenantKey,
          query: {
            regularGroupId: regularGroupId!,
            includeDispatched: true,
            page: -1
          }
        },
        signal
      ),
    enabled: enabled && !!regularGroupId,
    staleTime: 0
  })
}
